import { atom } from 'recoil';

export const withShowNotificationDrawer = atom({
  key: 'notifications.showNotificationDrawer',
  default: false
});
